"use strict";
/********************************************************************************
  HxVirtualizedCollection.ts

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxVirtualizedCollection = void 0;
var HxCollectionChange_1 = require("./HxCollectionChange");
var HxObject_1 = require("./HxObject");
var HxVirtualizedCollection = /** @class */ (function (_super) {
    __extends(HxVirtualizedCollection, _super);
    function HxVirtualizedCollection(objectId, objectType, itemIds, storageSequenceNumber, activeSet) {
        var _this = _super.call(this, objectId, objectType, storageSequenceNumber, activeSet) || this;
        _this._itemIds = [];
        _this._itemIds = itemIds;
        return _this;
    }
    Object.defineProperty(HxVirtualizedCollection.prototype, "totalItemCount", {
        get: function () {
            return this._itemIds.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HxVirtualizedCollection.prototype, "itemIds", {
        get: function () {
            return this._itemIds;
        },
        set: function (itemIds) {
            this._itemIds = itemIds;
        },
        enumerable: false,
        configurable: true
    });
    // Items are loaded from storage and returned to the getOrFetchItems method to be placed into the cache.
    HxVirtualizedCollection.prototype.loadItems = function (start, count, sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var itemIds, loadedItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        itemIds = this._itemIds.slice(start, start + count);
                        return [4 /*yield*/, this.activeSet.getVirtualizedCollectionItems(this.objectId, itemIds, sessionId)];
                    case 1:
                        loadedItems = _a.sent();
                        return [2 /*return*/, Promise.resolve(loadedItems)];
                }
            });
        });
    };
    HxVirtualizedCollection.prototype.getItemsById = function (startItemObjectId, count, sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var isStartItemNil, startIndex, requestedItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isStartItemNil = startItemObjectId === undefined || startItemObjectId === null || startItemObjectId.isNil();
                        startIndex = isStartItemNil ? 0 : this.itemIds.findIndex(function (itemId) { return itemId.isEqual(startItemObjectId); });
                        if (startIndex < 0 || startIndex > this.totalItemCount)
                            return [2 /*return*/, Promise.resolve(null)];
                        if (startIndex + count > this.totalItemCount)
                            count = this.totalItemCount - startIndex;
                        if (this.totalItemCount === 0 || count === 0)
                            return [2 /*return*/, Promise.resolve([])];
                        return [4 /*yield*/, this.loadItems(startIndex, count, sessionId)];
                    case 1:
                        requestedItems = _a.sent();
                        return [2 /*return*/, Promise.resolve(requestedItems)];
                }
            });
        });
    };
    HxVirtualizedCollection.prototype.applyVirtualizedCollectionUpdates = function (update) {
        var _this = this;
        update.changes.forEach(function (update) {
            switch (update.type) {
                case HxCollectionChange_1.HxCollectionChangeType.ItemCreated:
                    {
                        _this.itemIds.splice(update.index, 0, update.objectId);
                        break;
                    }
                case HxCollectionChange_1.HxCollectionChangeType.ItemRemoved:
                    {
                        _this.itemIds.splice(update.index, 1);
                        break;
                    }
            }
        });
    };
    return HxVirtualizedCollection;
}(HxObject_1.HxObject));
exports.HxVirtualizedCollection = HxVirtualizedCollection;
exports.default = HxVirtualizedCollection;
